export const separationBetweenControlDropdowns = 1; //in rem
